import FinancialReporting from "../components/FinancialReporting/FinancialReportingSearchReport";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import { All, SortDirection } from "../interfaces";
import { updateSortOrder } from "../common/actions";
import { initialAppState } from "../common/reducers/appState";

function mapStateToProps({ appState }: All) {
  return {
    appState: appState.financialReporting,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateSort: (sortField: string, sortDirection: SortDirection) => {
      dispatch(updateSortOrder(sortField, sortDirection));
    },
    resetState: () => {
      dispatch(actions.resetState(initialAppState.financialReporting));
    },
    updateFilters: (cert: string) => {
      dispatch(actions.updateFilter("cert", cert));
    },
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(FinancialReporting);
